import React from "react";
import { Marker } from "react-google-maps";
import { MARKER } from "react-google-maps/lib/constants";

import { getVenueMarkerIcon } from "../../../../services/venueCategories";
import MapScreenInfoBox from "../../../MapScreenInfoBox";

// Not optimized, so each marker is its own <img> and the SVG pulse of the cart
// screens plays (Google freezes animations of optimized markers).
// ponytail: every venue marker is a DOM node; if /map slows down with many
// screens, unoptimize only the cart ones (optimized can't change after mount).
const MARKER_OPTIONS = { optimized: false };
// How long a detail pin takes to rise on hover (and to land back).
const LIFT_MS = 160;

// Per-display marker. PureComponent guarantees that hovering over one screen
// does not re-render any other markers, since their props (display, isHovered,
// isSelected, isOnCart) are all stable references / primitives.
class DisplayMarker extends React.PureComponent {
  markerRef = React.createRef();
  liftTarget = this.getLiftTarget();
  lift = this.liftTarget;

  handleClick = () => this.props.openDisplay(this.props.display);

  componentDidUpdate() {
    const target = this.getLiftTarget();
    if (target !== this.liftTarget) this.animateLift(target);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.liftFrame);
  }

  getLiftTarget() {
    const { variant, isHovered, isSelected } = this.props;
    return variant === "detail" && (isHovered || isSelected) ? 1 : 0;
  }

  getIcon(lift) {
    const { display, variant, isOnCart, isHovered, isSelected } = this.props;
    return getVenueMarkerIcon(display, { variant, isOnCart, isHovered: isHovered || isSelected, lift });
  }

  // The icon prop already holds the final frame; this plays the frames in
  // between on the raw marker, so the pin rises (or lands) smoothly.
  animateLift(target) {
    this.liftTarget = target;
    cancelAnimationFrame(this.liftFrame);
    const marker = this.markerRef.current && this.markerRef.current.state[MARKER];
    if (!marker) {
      this.lift = target;
      return;
    }
    const from = this.lift;
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / LIFT_MS);
      const eased = 1 - (1 - t) * (1 - t);
      this.lift = from + (target - from) * eased;
      marker.setIcon(this.getIcon(this.lift));
      if (t < 1) this.liftFrame = requestAnimationFrame(step);
    };
    // First frame right away, so the final icon set by <Marker> never shows.
    step(start);
  }

  render() {
    const {
      display,
      isHovered,
      isSelected,
      isOnCart,
      handleClose,
      paymentStatus,
      addDisplayToCart,
      removeDisplayFromCart,
      getAudience,
      cart,
      programmatic,
      date_from,
      date_to,
      editCampaignActive,
      listBundle,
      initialBackup,
      hasInitialBackup
    } = this.props;

    // Cached per category/state, so the reference stays stable across renders.
    const icon = this.getIcon();

    return (
      <Marker
        ref={this.markerRef}
        defaultOptions={MARKER_OPTIONS}
        zIndex={isHovered || isOnCart ? 99 : 1}
        icon={icon}
        onClick={this.handleClick}
        position={{
          lat: parseFloat(display.latitude),
          lng: parseFloat(display.longitude),
        }}
      >
        {isSelected && (
          <MapScreenInfoBox
            display={display}
            handleClose={handleClose}
            onCart={isOnCart}
            paymentStatus={paymentStatus}
            addDisplayToCart={addDisplayToCart}
            removeDisplayFromCart={removeDisplayFromCart}
            getAudience={getAudience}
            cart={cart}
            programmatic={programmatic}
            date_from={date_from}
            date_to={date_to}
            editCampaignActive={editCampaignActive}
            listBundle={listBundle}
            initialBackup={initialBackup}
            hasInitialBackup={hasInitialBackup}
          />
        )}
      </Marker>
    );
  }
}

export default DisplayMarker;
